module.exports = __webpack_public_path__ + "img/1009b_cover.ce000d34.jpg";